import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const groupsRef = db.ref('groups')
const usersRef = db.ref('users')
const groupNameKeyRef = db.ref('_meta/namekeys/groups')
const currentGroupsRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/groups') }

export const groupsModule = {
  namespaced: true,
  state: {
    groups: {},
    currentGroups: {},
    groupNameKeys: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    // [getterConstants.SET_DEFAULT_USER_INFO]: firebaseAction((context, value) => {
    //   const setEmailRegistRef = db.ref('users')
    //   setEmailRegistRef.set(value)
    // }),
    [getterConstants.GET_GROUPS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_GROUPS')
      bindFirebaseRef('groups', groupsRef, { wait: true })
    }),
    [getterConstants.GET_GROUP_NAME_KEY]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_GROUP_NAME_KEY')
      bindFirebaseRef('groupNameKeys', groupNameKeyRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_GROUPS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_GROUPS', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentGroups', currentGroupsRef(currentUserId), { wait: true })
    }),
    [getterConstants.REMOVE_GROUP]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      let removeItemRef = db.ref('users/' + currentUserId + '/' + value.target).child(value.id)
      removeItemRef.remove()
    }),
    [getterConstants.REMOVE_CURRENTGROUP]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      let removeItemRef = db.ref('users/' + currentUserId + '/' + value.target)
      removeItemRef.child(value.id).set(-1)
    }),
    [getterConstants.SET_GROUP_INACTIVE]: firebaseAction((context, value) => {
      groupsRef.child(value.id).child('isInactive').set(true)
    }),
    [getterConstants.SET_FOLLOWING_GROUPS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const setFollowingGroupsRef = db.ref('users/' + currentUserId + '/following/groups')
      if (value.oldFollowingGroups) {
        for (let key in value.oldFollowingGroups) {
          // console.log(value[key])
          setFollowingGroupsRef.child(value.oldFollowingGroups[key]).remove()
        }
      }
      if (value.groups) {
        for (let key in value.groups) {
          setFollowingGroupsRef.child(value.groups[key]).set(1)
        }
      }
    }),
    [getterConstants.SET_NEW_GROUP]: firebaseAction((context, value) => {
      if (!value.groupId) {
        const group = groupsRef.push(value)
        for (let memberId in value.members) {
          if (value.ownerId === memberId) {
            usersRef.child(memberId).child('groups').child(group.key).set(1)
          } else {
            usersRef.child(memberId).child('groups').child(group.key).set(0)
          }
        }
      } else {
        // 編集用
        for (let memberId of value.oldMembers.filter(x => !value.members[x])) {
          usersRef
            .child(memberId)
            .child('groups')
            .child(value.groupId)
            .remove()
        }
        for (let memberId of Object.keys(value.members)) {
          usersRef
            .child(memberId)
            .child('groups')
            .child(value.groupId)
            .set(value.ownerId === memberId ? 1 : 0)
        }
        const newValue = {
          groupName: value.groupName,
          members: value.members,
          ownerId: value.ownerId,
          isOrganization: value.isOrganization || null,
          parentGroup: value.parentGroup || null,
          childGroups: value.childGroups || null
        }
        groupsRef.child(value.groupId).set(newValue)
      }
    })
  },
  getters: {
    getGroups: state => state.groups,
    getGroupNameKeys: state => state.groupNameKeys,
    getCurrentActiveGroups: state => {
      let groups = {}
      for (let key in state.currentGroups) {
        if (state.currentGroups[key] >= 0) {
          groups[key] = state.currentGroups[key]
        }
      }
      return groups
    },
    getCurrentGroups: state => state.currentGroups,
    getGroupsByIds: state => groupIds => {
      let groups = {}
      for (const groupId of groupIds) {
        if (state.groups[groupId]) {
          if (!(state.groups[groupId].hasOwnProperty('isInactive') && state.groups[groupId].isInactive)) {
            groups[groupId] = state.groups[groupId]
          }
        }
      }
      return groups
    },
    getGroupById: state => groupId => {
      if (state.groups[groupId]) {
        return state.groups[groupId]
      } else {
        return {}
      }
    },
    getOnlyGroupsByIds: state => groupIds => {
      let groups = {}
      for (const groupId of groupIds) {
        if (state.groups[groupId] && !state.groups[groupId].hasOwnProperty('isOrganization')) {
          if (!(state.groups[groupId].hasOwnProperty('isInactive') && state.groups[groupId].isInactive)) {
            groups[groupId] = state.groups[groupId]
          }
        }
      }
      return groups
    },
    getGroupMembersByIds: state => groupIds => {
      let groupMembers = new Set()
      if (state.groups) {
        for (const groupId of groupIds) {
          if (state.group[groupId] && state.group[groupId].members) {
            for (const member of Object.values(state.group[groupId].members)) {
              groupMembers.add(member)
            }
          }
        }
      }
      return [...groupMembers]
    },
    getGroupsByText: state => text => {
      let groups = {}
      const regexp = new RegExp(text, 'i')
      const stateGroups = state.groups
      for (let group in stateGroups) {
        if (!stateGroups[group].groupName) {
          continue
        }
        if (stateGroups[group].groupName.match(regexp)) {
          groups[group] = stateGroups[group]
        }
      }
      return groups
    },
    getOnlyGroupsByText: state => text => {
      let groups = {}
      const regexp = new RegExp(text, 'i')
      const stateGroups = state.groups
      for (let group in stateGroups) {
        if (!stateGroups[group].groupName || stateGroups[group].hasOwnProperty('isOrganization') || stateGroups[group].hasOwnProperty('isInactive')) {
          continue
        }
        if (stateGroups[group].groupName.match(regexp)) {
          groups[group] = stateGroups[group]
        }
      }
      return groups
    },
    getOnlyGroupsBySearchText: (state, getters) => searchText => {
      let currentGroup = getters.getCurrentGroups
      delete currentGroup['.key']
      delete currentGroup['.value']
      if (searchText.length === 0) {
        if (!Object.keys(currentGroup).length) {
          return {}
        } else {
          return getters.getOnlyGroupsByIds(Object.keys(currentGroup))
        }
      } else {
        if (!Object.keys(currentGroup).length) {
          return {}
        } else {
          return getters.getOnlyCurrentGroupsByText(searchText, getters.getGroupsByIds(Object.keys(currentGroup)))
        }
      }
    },
    getCurrentGroupsByText: state => (text, stateGroups) => {
      let groups = {}
      const regexp = new RegExp(text, 'i')
      // const stateGroups = state.currentGroups
      for (let group in stateGroups) {
        if (!stateGroups[group].groupName) {
          continue
        }
        if (stateGroups[group].groupName.match(regexp)) {
          groups[group] = stateGroups[group]
        }
      }
      return groups
    },
    getOnlyCurrentGroupsByText: state => (text, stateGroups) => {
      let groups = {}
      const regexp = new RegExp(text, 'i')
      // const stateGroups = state.currentGroups
      for (let group in stateGroups) {
        if (!stateGroups[group].groupName) {
          continue
        }
        if (stateGroups[group].hasOwnProperty('isOrganization')) {
          continue
        }
        if (stateGroups[group].groupName.match(regexp)) {
          groups[group] = stateGroups[group]
        }
      }
      return groups
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/groups.js